import { Box, TextField, Typography } from '@mui/material';
import type { WizardData } from './wizardTypes';

interface Props {
    data: WizardData;
    onChange: (patch: Partial<WizardData>) => void;
    compact?: boolean;
}

const Step2Name = ({ data, onChange, compact }: Props) => {
    return (
        <Box>
            {!compact && (
                <>
                    <Typography variant="h6" sx={{ fontWeight: 800, mb: 0.5 }}>
                        이 자동화의 이름을 정해주세요
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
                        나만 보는 이름이에요. 알아보기 쉽게 적으면 됩니다.
                    </Typography>
                </>
            )}
            <TextField
                fullWidth
                autoFocus={!compact}
                placeholder="예) 무료 가이드 발송"
                value={data.name}
                onChange={(ev) => onChange({ name: ev.target.value })}
                helperText='예시: "스타일 팁 발송", "비타민 추천 가이드", "이벤트 쿠폰 안내"'
                inputProps={{ maxLength: 50 }}
            />
        </Box>
    );
};

export default Step2Name;
